module.exports = __webpack_public_path__ + "static/img/sq.b813dbe2.png";